<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md3>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-toolbar-title>Список драйверов</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="addDriver(null)" v-if="accesses.drivers_create"><v-icon class="mx-0">add</v-icon></v-btn>
          </v-system-bar>
          <v-list dense>
            <v-list-tile v-if="drivers_list.length===0">Показатели данного типа отсутствуют</v-list-tile>
            <v-list-tile v-else v-for="(item, index) in drivers_list" :key="item.id" @click="getDriver(item.id)" class="indicator__list-item"
                         :class="{'blue lighten-4':(driverId===item.id)}">
              <v-list-tile-content>
                <v-list-tile-title v-html="item.name"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon class="green--text" @click.stop="showCode(item)"><v-icon>mdi-code-tags</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="item.can_edit && accesses.drivers_update">
                <v-btn icon class="indigo--text" @click.stop="addDriver(item)"><v-icon>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="item.can_delete && accesses.drivers_delete">
                <v-btn icon class="red--text" @click.stop="deleteDriver(item)"><v-icon>close</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 md9>
        <v-card v-if="driverId">
          <v-system-bar color="accent" dark window style="width: 100%">
            <v-icon>mdi-settings-outline</v-icon>
            <v-toolbar-title class="ml-1">Параметры</v-toolbar-title>
          </v-system-bar>
          
          <v-flex xs12 v-if="currentNode" class="pa-3">
            <h1>{{currentNode.name}}</h1>
            <p>{{currentNode.description}}</p>
            <p><b>Привязанные статистики: </b>{{getDriverStatisticsNames}}</p>
            <p><b>Значение: </b>{{currentNode.options.value}}</p>
            <p><b>Предпросмотр:</b></p>
            <div @mouseenter="$event.target.style.background=currentNode.options.hover"
                 @mouseleave="$event.target.style.background=currentNode.options.bgcolor"
                 :style="{
                          cursor: 'pointer',
                          textAlign:'center',
                          fontSize:currentNode.options.size+'px',
                          width:currentNode.options.width+'px',
                          height:currentNode.options.height+'px',
                          lineHeight:currentNode.options.height+'px',
                          color: currentNode.options.color,
                          background:currentNode.options.bgcolor
                    }">{{currentNode.options.text}}</div>
  
            <h2 class="mt-2">Код для вставки</h2>
            <p class="mb-0">Вставьте этот код в то место, где должен отображаться драйвер</p>
            <code>&lt;div id="dms-btn-widget"&gt;&lt;/div&gt;</code>
            <p class="mb-0 mt-4">Затем поместите следующий код внутри тега <b>head</b> или <b>body</b></p>
            <code>&lt;script src="https://dev18.dantser.net/static/widgets/dmsButton.js?id={{driverId}}"&gt;&lt;/script&gt;</code>
            
          </v-flex>
          <v-flex xs12 v-else class="text-xs-center py-5">
            <p>Загрузка ...</p>
            <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="1000" scrollable @keydown.esc="dialog=false" persistent>
      <component v-if="dialog" :is="currentComponent" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  import DriverForm from './Forms/DriverForm'
  import CodeForm from './Forms/CodeForm'
  
  export default {
    name : 'DriverList',
  
    computed:{
      ...mapGetters('analytics_old/indicators', ['indicators']),
      ...mapGetters('analytics_old/drivers', ['drivers_list']),
      accesses(){
        return this.$store.state.app.account.accesses['analytics'] || {}
      },
      getDriverStatisticsNames(){
        let result = ''
        if(this.currentNode && this.currentNode.statistics.length>0){
          for(let id of this.currentNode.statistics){
            let statistic = this.statistics.find( el => el.id===id)
            if(statistic) result+=statistic.name+', '
          }
          result = result.substring(0, result.length-2)
        } else {
          result = 'Отсутствуют'
        }
        return result
      },
    },
    
    data() {
      return {
        dialog: false,
        currentComponent: null,
        currentNode: null,
        driverId: null,
        formProps: {}
      }
    },
    
    created(){
      if (!this.accesses.drivers_access){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      }
      this.$store.dispatch('analytics_old/indicators/list')
      this.$store.dispatch('analytics_old/drivers/list')
    },
    
    methods : {
      getDriver(id){
        this.driverId = id
        this.currentNode = null
        this.$store.dispatch('analytics_old/drivers/view', id).then( driver => {
          this.currentNode = driver
        })
      },
      
      addDriver(data){
        this.currentComponent = DriverForm
        this.formProps = {}
        if(data!=null){
          this.$store.dispatch('analytics_old/drivers/view', data.id).then( response => {
            data.options = response.options
            data.scope = response.scope
            data.statistics = response.statistics
            this.formProps = {
              data: data,
              editMode: true
            }
            this.dialog = true
          })
        } else {
          this.dialog = true
        }
      },
      
      deleteDriver(item){
        this.$dmsAgree({message: 'Вы уверены, что хотите удалить выбранный элемент?', title: 'Удаление драйвера'}).then( confirm => {
          this.$store.dispatch('analytics_old/drivers/delete', item.id)
        })
      },
  
      showCode(data){
        this.currentComponent = CodeForm
        this.formProps = {
          data: data,
        }
        this.dialog = true
      },
      
      saveChanges(){
        this.dialog = false
      },
      
    }
  }
</script>
<style>
  .indicator__list-item .v-list__tile__action{
    min-width: 30px;
  }
  
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Drivers/DriverList.vue